<template>
    <div class="ba-notice-board-v5 ba-card">
        <div class="header" v-html="view.translations.header"></div>
        <div class="search-grid">
            <div class="search-input-v5">
                <span class="fa fa-search"></span>
                <input type="text" placeholder="Subject, Theme, Title, Keywords" v-model="filter" />
                <transition name="fade">
                    <span
                        class="fa fa-times-circle"
                        v-show="filter != ''"
                        @click="clearFilter"
                    ></span>
                </transition>
            </div>
            <fs5-button
                :label="'Filter'"
                :btn-type="'primary'"
                :text-transform-type="'uppercase'"
                :disabled="filter == ''"
                @clicked="filterNotices"
            ></fs5-button>
        </div>
        <transition-group name="fade-in" mode="out-in" tag="div" >
            <fs5-notice-card-v5
                v-show="filteredNotices.length > 0"
                v-for="(aviso, index) in filteredNotices"
                :key="aviso.id+'-'+index"
                :view="aviso"
                :lang="view.lang"
                :langs="view.langs"
            />

            <infinite-loading
                :key="1234567"
                @infinite="infiniteHandler"
                spinner="spiral"
                ref="infiniteLoading"
            >
                <div
                    slot="no-more"
                    class="no-more-items-list"
                    v-html="view.translations['label_no_more_results']"
                ></div>
                <div
                    slot="no-results"
                    class="empty-list"
                    v-html="view.translations['nenhuma-mensagem']"
                ></div>
            </infinite-loading>
        </transition-group>
        <transition name="fade">
            <div
                :class="['scroll-top-button', (livezillaOpen ? 'position-us-open' : 'position-us-closed') ]"
                v-show="showScrollTopButton"
                @click="topFunction"
            >
                <span class="fa fa-arrow-up"></span>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'fs5-notice-board',
        props: ['view'],
        data: function () {
            return {
                filter: '',
                allNotices: [],
                filteredNotices: [],
                skip: 5,
                offset: 0,
                page: 0,
                showScrollTopButton: false,
                livezillaOpen: false
            }
        },
        methods: {
            clearFilter() {
                this.filter = '';
                this.filterNotices();
            },
            filterNotices(){
                let vm = this
                if(this.filter == '')
                {
                    this.$set(this.$data,'filteredNotices', JSON.parse(JSON.stringify(this.allNotices)))
                }
                else
                {
                    let filteredNotices = this.allNotices.filter(function(obj) {
                        let rg = new RegExp(`${vm.filter}`, 'gi');

                        let title = obj.title;

                        let subject = obj.subject;

                        return ( title.search(rg) !== -1 || subject.search(rg) !== -1 || obj.description.search(rg) !== -1 );
                    });
                    filteredNotices = JSON.parse(JSON.stringify(filteredNotices));

                    this.$set(this.$data, 'filteredNotices', filteredNotices);
                }
            },
            infiniteHandler: async function($state) {
                let vm = this
                try{
                    let res = await axios.post(
                        this.view.urls.rota_office_mural_get_notices,
                        {
                            skip: this.skip,
                            offset: (this.page*this.skip)
                        },
                        {
                            headers: {
                                'Content-Type': 'application/json',
                            }
                        }
                    );
                    if(res.data.length > 0) {
                        this.page++;
                        this.offset = (this.page*this.skip);
                        this.allNotices.push(...res.data)
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                } catch (e) {
                    // $state.complete();
                } finally {
                    this.filterNotices()
                }
            },
            scrollFunction: function() {
                if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                    this.showScrollTopButton = true
                } else {
                    this.showScrollTopButton = false
                }
            },
            topFunction: function() {
                window.scrollTo({top: 0, behavior: 'smooth'});
            },
            toggleLivezillaButton() {
                this.livezillaOpen = !this.livezillaOpen
            }
        },
        watch: {
            filter: function(newVal, oldVal) {
                if(newVal == '') {
                    this.clearFilter();
                }
            }
        },
        mounted() {
            // console.log('assuntos: ',this.view);
            let vm = this;
            window.onscroll = function() { vm.scrollFunction()};
            this.$refs.infiniteLoading.isLoading = true;
            this.infiniteHandler();

            $(document).ready(function() {
                if(vm.view.lang != 'br') {
                    let interval = setInterval(function(){
                        let btn = document.getElementById('livezilla_wm');
                        if(btn !== null) {
                            $('#livezilla_wm').click(function(){
                                vm.toggleLivezillaButton();
                            });
                            clearInterval(interval);
                        }
                    }, 5000);
                }
            });
        },
    }
</script>

<style scoped lang="scss">
    @import '../../../../scss/extras/_variables';
    .ba-notice-board-v5{
        font-family: $fs5-font2;
        font-size: 0.625rem;
        .header{
            color: $fs5-color11;
            font-family: $fs5-font2;
            line-height: 1.2;
            font-weight: 900;
            font-size: 2.1875rem; /* 35px; */
            margin-bottom: 18px;
            text-transform: uppercase;
        }
        div[mode=out-in]{
            font: inherit;
        }
        .search-grid{
            font: inherit;
            margin-bottom: 3.9em;
            display: grid;
            grid-template-columns: auto 10.1em;
            grid-template-rows: 4.8em;
            column-gap: 1.5em;
            .search-input-v5{
                font: inherit;
                position: relative;

                input{
                    font: inherit;
                    font-size: 1.2em;
                    line-height: 1.2;
                    font-weight: 700;
                    min-height: 4em;
                    color: $fs5-color-24!important;

                    background-color: $fs5-color17;
                    outline: 0!important;
                    border-radius: 0.5em;
                    border: none;
                    min-width: 100%;

                    padding: 0.833333333em 3.333333333em 0.833333333em 3.333333333em;
                    &::placeholder{
                        color: $fs5-color11!important;
                    }
                }
                span:first-child{
                    font-size: inherit;
                    font-size: 2.2em;

                    position: absolute;
                    top: 0.454545455em;
                    left: 0.454545455em;

                    color: $fs5-color11;
                    &::before,
                    &::after{
                        color: inherit!important;
                    }
                }
                span:last-child{
                    font-size: inherit;
                    font-size: 2.2em;

                    position: absolute;
                    top: 0.55em;
                    right: 0.454545455em;

                    color: $fs5-color11;
                    &::before,
                    &::after{
                        color: inherit!important;
                    }

                    &:hover{
                        cursor: pointer;
                    }
                }
            }
        }
        .empty-list{
            font-family: "Lato";
            color: $fs5-color11;
            line-height: 1.2;
            font-weight: 900;
            font-size: 20px;
            text-align: center;

            margin-top: 2em;
        }
        .no-more-items-list{
            font-family: "Lato";
            color: $fs5-color11;
            line-height: 1.2;
            font-weight: 900;
            font-size: 20px;
            text-align: center;

            margin-top: 1em;
        }

        .scroll-top-button{
            font: inherit;

            background-color: $fs5-color5;

            width: 4.8em;
            height: 4.8em;

            border-radius: 50%;

            display: flex;
            align-items: center;
            justify-content: center;
            // transition: all 0.3s;

            position: fixed!important;

            &.position-br{
                position: fixed!important;
                right: 40px;
                bottom: 30px;
                left: auto;
                top: auto;
            }

            &.position-us-open{
                position: fixed!important;
                right: 40px;
                bottom: 248px;
                left: auto;
                top: auto;
            }
            &.position-us-closed{
                position: fixed!important;
                right: 40px;
                bottom: 88px;
                left: auto;
                top: auto;
            }

            &:hover{
                cursor: pointer;
                box-shadow: 0px 4px 11px $fs5-color8;
            }

            .fa-arrow-up{
                font-size: inherit;
                font-size: 1.8em;
                color: $fs5-color2;

                &::after,
                &::before{
                    color: inherit!important;
                }
            }

        }
    }

    @media screen and (max-width: 768px) {
        .ba-notice-board-v5{
            .search-grid{
                grid-template-columns: 1fr;
                row-gap: 1em;
            }
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .fade-in-enter-active {
        transition: all 0.5s ease;
    }

    .fade-in-leave-active {
        transition: all 0.5s ease;
    }

    .fade-in-enter, .fade-in-leave-to {
        position: absolute; /* add for smooth transition between elements */
        opacity: 0;
    }
</style>

<style lang="scss">
#main{
    transform: none!important;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/notice_board/index.vue